const baseImagesURL = 'https://cdn.cointracker.io/static/images';
export const iconsImagesURL = baseImagesURL + '/icons';
export const thirdPartyImagesURL = baseImagesURL + '/third_party';
export const fiatlImagesUrl = baseImagesURL + '/fiats';
export const walletsImagesUrl = baseImagesURL + '/wallets';

export const cryptoIconsCmcURL64 =
  'https://cdn.cointracker.io/crypto-icons/cmc/64x64';
